export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGOUT = 'LOGOUT';

export const VERIFY = 'VERIFY';
export const VERIFY_ERROR = 'VERIFY_ERROR';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';

export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const SAVE_SETTINGS_ERROR = 'SAVE_SETTINGS_ERROR';
export const SAVE_SETTINGS_SUCCESS = 'SAVE_SETTINGS_SUCCESS';

export const SAVE_PFCONTRIBUTION = 'SAVE_SETTINGS';
export const SAVE_PFCONTRIBUTION_ERROR = 'SAVE_SETTINGS_ERROR';
export const SAVE_PFCONTRIBUTION_SUCCESS = 'SAVE_SETTINGS_SUCCESS';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

export const UPDATE_FISCAL_YEAR = 'UPDATE_FISCAL_YEAR';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';



// WEBPACK FOOTER //
// ./src/store/constants.js